import { useCallback } from "react";

/**
 * Hook to talk to the native app when the SPA is loaded inside its WebView.
 * Returns isInHostApp so callers can hide app-only actions on the web,
 * and notifyBookingComplete to hand the user back to the app after booking.
 */
export default function useHostApp() {
  const isInHostApp = typeof window !== "undefined" && !!window.ReactNativeWebView;

  const notifyBookingComplete = useCallback((appointment) => {
    if (!window.ReactNativeWebView) return;

    window.ReactNativeWebView.postMessage(
      JSON.stringify({ action: "bookingComplete", appointment })
    );
  }, []);

  const closeHostApp = useCallback(() => {
    if (!window.ReactNativeWebView) return;

    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "close" }));
  }, []);

  return { isInHostApp, notifyBookingComplete, closeHostApp };
}
